import { View } from 'react-native'
import {
  getSteppedActiveSegmentIndex,
  isSteppedAtMinimum,
  resolveSteppedSegmentCount,
} from './steppedTrackUtils'
import {
  sliderConfig,
  sliderThumbOffset,
  sliderThumbStyle,
  sliderTrackStyle,
} from './styles'

type Props = {
  minimumValue: number
  maximumValue: number
  value: number
  step: number
  steps?: number
  colorTrackFront: string
  colorTrackBack: string
}

export default function SteppedTrackVisual({
  minimumValue,
  maximumValue,
  value,
  step,
  steps,
  colorTrackFront,
  colorTrackBack,
}: Props) {
  const steppedParams = { minimumValue, maximumValue, step, steps }
  const segmentCount = resolveSteppedSegmentCount(steppedParams)
  const isAtMinimum = isSteppedAtMinimum(value, minimumValue)
  const activeIndex = getSteppedActiveSegmentIndex(value, steppedParams)

  return (
    <View
      pointerEvents="none"
      style={{
        height: sliderConfig.trackRowHeight,
        width: '100%',
        justifyContent: 'center',
      }}
    >
      <View
        style={{
          height: sliderConfig.trackRowHeight,
          width: '100%',
          flexDirection: 'row',
          alignItems: 'center',
          gap: sliderConfig.segmentGap,
        }}
      >
        {Array.from({ length: segmentCount }, (_, index) => (
          <View
            key={index}
            style={{
              position: 'relative',
              height: sliderConfig.trackRowHeight,
              flex: 1,
              justifyContent: 'center',
            }}
          >
            <View
              style={{
                ...sliderTrackStyle,
                width: '100%',
                backgroundColor:
                  activeIndex >= 0 && index <= activeIndex
                    ? colorTrackFront
                    : colorTrackBack,
              }}
            />
            {isAtMinimum && index === 0 && (
              <View
                style={{
                  position: 'absolute',
                  left: -sliderThumbOffset,
                  top: 0,
                  backgroundColor: colorTrackFront,
                  ...sliderThumbStyle,
                }}
              />
            )}
            {!isAtMinimum && index === activeIndex && (
              <View
                style={{
                  position: 'absolute',
                  right: -sliderThumbOffset,
                  top: 0,
                  backgroundColor: colorTrackFront,
                  ...sliderThumbStyle,
                }}
              />
            )}
          </View>
        ))}
      </View>
    </View>
  )
}
